import { styled } from "@mui/material/styles";
import { Checkbox, FlexRow, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { CustomViewCompositeViewItem } from "./CustomViewCompositeStore";

const StyledFlexRow = styled(FlexRow)(({
	theme,
}) => ({
	paddingBottom: 12,
	paddingLeft: 34,
	paddingTop: 8,
}));

interface SelectionProps {
	view: CustomViewCompositeViewItem;
}

const CompositeViewItem: FunctionComponent<SelectionProps> = observer(({ view }) => {
	const { hasCustomViews,
		name,
		options,
		selectedCustomView,
		visible,
		customViewSelectChangeHandler,
		customViewDropDownClickHandler,
		visibleCheckBoxClickHandler,
	} = view;

	return (
		<div>
			<FlexRow>
				<Checkbox
					checked={visible}
					labelProps={{
						label: name,
						sx: {
							"&>.MuiFormControlLabel-label": {
								fontSize: "14px",
								fontWeight: 700,
								lineHeight: "20px",
							},
						},
					}}
					onChange={(e, value) => visibleCheckBoxClickHandler(value)}
				/>
			</FlexRow>
			<StyledFlexRow>
				{hasCustomViews && (
					<SingleSelect
						disableClearable
						disabled={!visible}
						fullWidth
						onChange={customViewSelectChangeHandler}
						onMouseDownCapture={(e) => customViewDropDownClickHandler(name)}
						options={options}
						value={selectedCustomView}
					/>
				)}
			</StyledFlexRow>
		</div>
	);
});

export default CompositeViewItem;